import React, { Component } from "react";
import Card from "../../components/Card";
import Action from "../../components/Action";
import DateOfBirthQuestion from "../../components/DateOfBirthQuestion";
import TextQuestion from "../../components/TextQuestion";
import ScrollToTop from "../../components/utils/ScrollToTop";
import Image from "../../components/Image";
import imageCatAndHousePlant from "../../images/cat-and-houseplant.png";
import {
  isDateValid,
  isDayValid,
  isMonthValid,
  isYearValid,
  validateNationalInsuranceNumber,
} from "../../shared/utils/validation";

class ClientDetails extends Component {
  constructor(props) {
    super(props);

    const errorMessages = {
      annualIncome: "Enter your annual income",
      dateOfBirth: "Enter your date of birth",
      nationality: "Enter your nationality",
      nationalInsuranceNumber: "Enter your National Insurance number",
      occupation: "Enter your occupation",
      companyName: "Enter the name of the company you work for or current work situation",
      phoneNumber: "Enter your phone number",
    };

    if (this.props.clientDetails) {
      this.state = {
        client: { ...this.props.clientDetails.client },
        errors: {},
        errorMessages: errorMessages,
        dateErrors: {},
      };
    } else {
      this.state = {
        client: {
          annualIncome: "",
          dateOfBirth: {
            day: "",
            month: "",
            year: "",
          },
          nationality: "",
          occupation: "",
          companyName: "",
          phoneNumber: "",
          nationalInsuranceNumber: "",
        },
        errors: {},
        errorMessages: errorMessages,
        dateErrors: {},
      };
    }
  }

  isBuying = (transactionType) => {
    return transactionType === "Buying" || transactionType === "BuyingAndSelling";
  };

  handleValidation() {
    const fields = { ...this.state.client };
    let errors = { ...this.state.errors };
    let errorMessages = { ...this.state.errorMessages };
    let formIsValid = true;

    if (!fields["annualIncome"]) {
      errors["annualIncome"] = true;
      formIsValid = false;
    }

    if (fields["annualIncome"] !== "" && !this.isMoneyValid(fields["annualIncome"])) {
      errors["annualIncome"] = true;
      errorMessages["annualIncome"] = "Please enter a valid amount";
      formIsValid = false;
    }

    if (!fields["dateOfBirth"].day || !fields["dateOfBirth"].month || !fields["dateOfBirth"].year) {
      errors["dateOfBirth"] = true;
      errorMessages["dateOfBirth"] = "Enter your date of birth";
      formIsValid = false;
    } else if (!isDateValid(fields["dateOfBirth"].day, fields["dateOfBirth"].month, fields["dateOfBirth"].year)) {
      errors["dateOfBirth"] = true;
      errorMessages["dateOfBirth"] = "Date of birth must be a real date";
      formIsValid = false;
    } else {
      errors["dateOfBirth"] = false;
      errorMessages["dateOfBirth"] = "Enter your date of birth";
    }

    if (!fields["nationality"]) {
      errors["nationality"] = true;
      formIsValid = false;
    }

    if (!fields["occupation"]) {
      errors["occupation"] = true;
      formIsValid = false;
    }

    if (!fields["companyName"]) {
      errors["companyName"] = true;
      formIsValid = false;
    }

    if (!fields["phoneNumber"]) {
      errors["phoneNumber"] = true;
      formIsValid = false;
    }

    if (this.isBuying(this.props.transactionType)) {
      const niResult = validateNationalInsuranceNumber(fields["nationalInsuranceNumber"]);
      if (niResult.hasError) {
        errors["nationalInsuranceNumber"] = true;
        errorMessages["nationalInsuranceNumber"] = niResult.message;
        formIsValid = false;
      } else {
        errors["nationalInsuranceNumber"] = false;
        errorMessages["nationalInsuranceNumber"] = "";
      }
    }

    this.setState({ errors, errorMessages });
    return formIsValid;
  }

  handleFieldValidation = (field) => (event) => {
    const isBlur = event.type === "blur";
    this.setState((prevState) => {
      let errors = { ...prevState.errors };
      const errorMessages = { ...prevState.errorMessages };

      if (!isBlur) {
        errors[field] = null;
      } else {
        if (!prevState.client[field]) {
          errors[field] = errorMessages[field];
        }
      }

      return { errors };
    });
  };

  handleDateFieldValidation = (field) => (datePart) => (value) => {
    this.setState((prevState) => {
      let dateErrors = { ...prevState.dateErrors };
      let errors = { ...prevState.errors };
      let errorMessages = { ...prevState.errorMessages };
      let dateField = { ...(dateErrors[field] || {}) };

      if (datePart === "day") {
        dateField["day"] = !isDayValid(value);
      }

      if (datePart === "month") {
        dateField["month"] = !isMonthValid(value);
      }

      if (datePart === "year") {
        dateField["year"] = !isYearValid(value);
      }

      dateErrors[field] = dateField;

      const allValues = Object.values(dateErrors[field]);
      const dateFieldIsValid = allValues.every((item) => item === false);

      if (!dateFieldIsValid) {
        errors[field] = true;
      } else {
        const dob = { ...prevState.client.dateOfBirth, [datePart]: value };
        if (dob.day && dob.month && dob.year && !isDateValid(dob.day, dob.month, dob.year)) {
          errors[field] = true;
          errorMessages[field] = "Date of birth must be a real date";
        } else {
          errors[field] = false;
          errorMessages[field] = "Enter your date of birth";
        }
      }

      return { errors, errorMessages, dateErrors };
    });
  };

  normaliseMoney = (m) => {
    const stripCharsRegex = /[£, ]/g;
    return m.replace(stripCharsRegex, "");
  };

  isMoneyValid = (money) => {
    const allowedCharsRegex = /^[0-9£,. ]+$/;
    if (allowedCharsRegex.test(String(money))) {
      const normalised = this.normaliseMoney(money);

      const decimalPlaceRegex = /^\d+\.?\d{0,2}$/;

      return decimalPlaceRegex.test(String(normalised));
    }
    return false;
  };

  handleMoneyValidation = (field) => (event) => {
    const isBlur = event.type === "blur";
    this.setState((prevState) => {
      let errors = { ...prevState.errors };
      let errorMessages = { ...prevState.errorMessages };

      if (!isBlur) {
        errors[field] = false;
      } else {
        if (!this.isMoneyValid(prevState.client[field])) {
          errors[field] = true;
          errorMessages[field] = "Please enter a valid amount";
        }
        if (!prevState.client[field]) {
          errors[field] = true;
          errorMessages[field] = "Please fill this in";
        }
      }

      return { errors, errorMessages };
    });
  };

  handleNationalInsuranceNumberValidation = (field) => (event) => {
    const isBlur = event.type === "blur";
    this.setState((prevState) => {
      let errors = { ...prevState.errors };
      let errorMessages = { ...prevState.errorMessages };

      if (!isBlur) {
        errors[field] = false;
        errorMessages[field] = "";
      } else {
        const result = validateNationalInsuranceNumber(prevState.client[field]);
        errors[field] = result.hasError;
        errorMessages[field] = result.message;
      }

      return { errors, errorMessages };
    });
  };

  handleInputChange = (field) => (event) => {
    let client = { ...this.state.client };
    client[field] = event;
    this.setState({ client });
  };

  handleDateChange = (field) => (event) => {
    let dateOfBirth = { ...this.state.client.dateOfBirth };
    dateOfBirth[field] = event.target.value;
    const updatedClient = { ...this.state.client, dateOfBirth: dateOfBirth };
    this.setState({ client: updatedClient });
  };

  saveClientDetails = (event) => {
    event.preventDefault();
    if (this.handleValidation()) {
      const client = { ...this.state.client };
      if (!this.isBuying(this.props.transactionType)) {
        delete client.nationalInsuranceNumber;
      }
      this.props.onStepComplete({
        clientDetails: { client },
      });
      return;
    }
  };

  render() {
    return (
      <React.Fragment>
        <ScrollToTop />
        <Card title="Your details" removeTopPadding>
          <p>
            When we start working on your case we'll need to do some identity checks. These details are essential for us
            to move quickly – the wrong information could hold things up.
          </p>

          <DateOfBirthQuestion
            value={this.state.client.dateOfBirth}
            onChange={this.handleDateChange}
            validate={this.handleDateFieldValidation("dateOfBirth")}
            validationError={this.state.errors.dateOfBirth ? this.state.errorMessages.dateOfBirth : null}
          />

          <TextQuestion
            question="Mobile number"
            type="tel"
            autoComplete="tel"
            value={this.state.client.phoneNumber || ""}
            valueEntered={this.handleInputChange("phoneNumber")}
            validate={this.handleFieldValidation("phoneNumber")}
            validationError={this.state.errors.phoneNumber ? this.state.errorMessages.phoneNumber : null}
          />

          <TextQuestion
            question="Nationality"
            value={this.state.client.nationality || ""}
            valueEntered={this.handleInputChange("nationality")}
            validate={this.handleFieldValidation("nationality")}
            validationError={this.state.errors.nationality ? this.state.errorMessages.nationality : null}
          />

          <TextQuestion
            question="Your job"
            hint="e.g. teacher, waiter, actor, etc."
            value={this.state.client.occupation || ""}
            valueEntered={this.handleInputChange("occupation")}
            validate={this.handleFieldValidation("occupation")}
            validationError={this.state.errors.occupation ? this.state.errorMessages.occupation : null}
          />

          <TextQuestion
            question="The name of the company you work for"
            hint="If you don't work for a company, briefly describe your current situation (e.g. self-employed, not in work, retired)"
            value={this.state.client.companyName || ""}
            valueEntered={this.handleInputChange("companyName")}
            validate={this.handleFieldValidation("companyName")}
            validationError={this.state.errors.companyName ? this.state.errorMessages.companyName : null}
          />

          <TextQuestion
            question="Annual income"
            hint="Enter the full amount before tax, including any bonuses"
            value={this.state.client.annualIncome || ""}
            valueEntered={this.handleInputChange("annualIncome")}
            validate={this.handleMoneyValidation("annualIncome")}
            validationError={this.state.errors.annualIncome ? this.state.errorMessages.annualIncome : null}
          />

          {this.isBuying(this.props.transactionType) && (
            // GOV.UK uses QQ 12 34 56 C as a deliberately invalid example
            // so it can never match a real person's NI number
            <TextQuestion
              question="National Insurance number"
              hint="It’s on your payslip. For example, QQ 12 34 56 C"
              value={this.state.client.nationalInsuranceNumber || ""}
              valueEntered={this.handleInputChange("nationalInsuranceNumber")}
              validate={this.handleNationalInsuranceNumberValidation("nationalInsuranceNumber")}
              validationError={
                this.state.errors.nationalInsuranceNumber ? this.state.errorMessages.nationalInsuranceNumber : null
              }
            />
          )}

          <Action onClick={this.saveClientDetails}>Continue</Action>
        </Card>
        <Image src={imageCatAndHousePlant} />
      </React.Fragment>
    );
  }
}

export default ClientDetails;
